import React, { Component } from 'react';
import './index.css';

import SummaryColumn from '../SummaryColumn'
import Column from '../Column'

function getLevels(groups, levels) {
  groups.forEach(group => {
    if(levels.length <= group.summary.depth)
      levels.push({
        field: group.summary.field,
        items: []
      })

    levels[group.summary.depth].items.push(group)

    if(group.leaf === true)
      return

    getLevels(group.values, levels)
  })
}

class Chartable extends Component {
  render() {
    // console.log(this.props.data)

    if(this.props.data.length === 0) {
      return (
        <div className="chartable">NO RESULTS</div>
      )
    }

    let levels = []
    getLevels(this.props.data, levels)
    // console.log(this.props.data, 'levels', levels)

    let h = 26

    // TODO use proper key, rather than i

    let cols = levels.map((level, i) => {
      return (
        <div key={i} className={"column col-" + i}>
          <Column items={level.items} field={level.field} h={h} />
        </div>
      )
    })

    let leaves = levels[levels.length - 1].items

    // Dummy column is to, hopefully, prevent browser re-scrolling after render (which results in a render-scroll infinite loop) on Linux Chromium
    // Chromium seems to fire a scroll event when the spacer element above the visible elements is resized after scrolling down
    return (
      <div className="chartable">
        <div className="dummy" style={{height: h * leaves.length + 'px', width: '1px', verticalAlign: 'top', display: 'inline-block'}} />
        <div className="columns">
          {cols}
          <SummaryColumn items={leaves} h={h} />
        </div>
      </div>
    )
  }
}

export default Chartable;



// WEBPACK FOOTER //
// ./src/Chartable/index.js